function pushDataLayer(data) {
	dataLayer.push({...data});
}

document.querySelectorAll('[data-analytics]').forEach((element) => {
	element.addEventListener('click', function (event) {
		pushDataLayer({
			event: 'internet_event',
			eventAction: element.id
		});
	});
	return;
});
